import axios from 'axios';
import { HOST_API_URL } from 'config';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API_URL });

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Failed')
);

export default axiosInstance;
